import { toast } from 'react-toastify';

export const ToastProvider = ({ children }) => children;

export const useToasts = () => {
  const addToast = (message, options = {}) => {
    const appearance = options?.appearance || 'info';
    switch (appearance) {
      case 'success':
        return toast.success(message);
      case 'error':
        return toast.error(message);
      case 'warning':
        return toast.warn(message);
      default:
        return toast.info(message);
    }
  };

  return {
    addToast,
    removeAllToasts: () => toast.dismiss(),
  };
};